// client/src/components/admin/league-form/DatesRegistrationSection.js
import React from 'react'
import { validateDates, formatDate } from './leagueFormUtils'

export default function DatesRegistrationSection({
  formData,
  errors,
  onChange,
  isFieldDisabled = () => false,
  leagueStatus = 'draft',
}) {
  const handleInputChange = (e) => {
    const { name, value } = e.target
    onChange({ [name]: value })
  }

  return (
    <div className="form-section">
      <h3>Dates and Registration</h3>
      <div className="form-row">
        <div className="form-group">
          <label htmlFor="registration_start">Registration Start*</label>
          <input
            id="registration_start"
            name="registration_start"
            type="date"
            value={formData.registration_start}
            onChange={handleInputChange}
            className={errors?.registration_start ? 'error' : ''}
            disabled={isFieldDisabled('registration_start')}
            title={
              isFieldDisabled('registration_start')
                ? `Cannot change registration start in ${leagueStatus} status`
                : ''
            }
          />
          {errors?.registration_start && (
            <span className="error-message">{errors.registration_start}</span>
          )}
        </div>

        <div className="form-group">
          <label htmlFor="registration_end">Registration End*</label>
          <input
            id="registration_end"
            name="registration_end"
            type="date"
            value={formData.registration_end}
            onChange={handleInputChange}
            className={errors?.registration_end ? 'error' : ''}
            disabled={isFieldDisabled('registration_end')}
            title={
              isFieldDisabled('registration_end')
                ? `Cannot change registration end in ${leagueStatus} status`
                : ''
            }
          />
          {errors?.registration_end && (
            <span className="error-message">{errors.registration_end}</span>
          )}
        </div>
      </div>

      <div className="form-row">
        <div className="form-group">
          <label htmlFor="play_start">Play Start*</label>
          <input
            id="play_start"
            name="play_start"
            type="date"
            value={formData.play_start}
            onChange={handleInputChange}
            className={errors?.play_start ? 'error' : ''}
            disabled={isFieldDisabled('play_start')}
            title={
              isFieldDisabled('play_start')
                ? `Cannot change play start in ${leagueStatus} status`
                : ''
            }
          />
          {errors?.play_start && (
            <span className="error-message">{errors.play_start}</span>
          )}
        </div>

        <div className="form-group">
          <label htmlFor="play_end">Play End*</label>
          <input
            id="play_end"
            name="play_end"
            type="date"
            value={formData.play_end}
            onChange={handleInputChange}
            className={errors?.play_end ? 'error' : ''}
            disabled={isFieldDisabled('play_end')}
            title={
              isFieldDisabled('play_end')
                ? `Cannot change play end in ${leagueStatus} status`
                : ''
            }
          />
          {errors?.play_end && (
            <span className="error-message">{errors.play_end}</span>
          )}
        </div>
      </div>
    </div>
  )
}

// Export helper functions to be used by parent component
export { validateDates, formatDate }
